export default __webpack_public_path__ + "static/media/bear3.951ca52c.png";